import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { useProfilesOptions } from "PFCore/hooks/queries/profiles/use_profiles_options";
import React from "react";
import { useTranslation } from "react-i18next";

type ReassignLabelProps = {
  sourceProfileIds: number[];
};

export const ReassignLabel = ({ sourceProfileIds }: ReassignLabelProps) => {
  const { t } = useTranslation(["bookingModule", "activities", "translation"]);

  const shouldDisplayProfileName = sourceProfileIds.length === 1; // profile name is needed only if single booking was selected
  const { data: sourceProfiles, isFetching: isSourceProfilesFetching } = useProfilesOptions(
    {
      value: sourceProfileIds,
      perPage: PER_PAGE_UNPAGINATED,
      profileVisibility: "with_suspended"
    },
    { enabled: shouldDisplayProfileName }
  );

  if (shouldDisplayProfileName) {
    if (isSourceProfilesFetching) {
      return <LoadingDots />;
    } else if (sourceProfiles?.entries[0]) {
      const profileFullName = getProfileName(sourceProfiles.entries[0]);
      return (
        <Typography withMargin variant="bodyRegular" tag="span">
          {t("bookingModule:bookings.reassign.sidePanel.reassignFromTo", { profileFrom: profileFullName })}
        </Typography>
      );
    }
  }

  return (
    <Typography withMargin variant="bodyRegular" tag="span">
      {t("bookingModule:bookings.reassign.sidePanel.reassignToAnotherWM")}
    </Typography>
  );
};
